var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27664 2.77758C9.30935 1.74081 10.9837 1.74081 12.0164 2.77758C13.0158 3.7809 13.048 5.3875 12.1129 6.42993L12.0162 6.53224L7.15285 11.4094C6.53327 12.0314 5.52873 12.0314 4.90915 11.4094C4.31651 10.8144 4.29074 9.86587 4.83204 9.23996L4.90937 9.15667L9.39759 4.65612C9.60416 4.44898 9.93888 4.44918 10.1452 4.65656C10.3343 4.84667 10.3499 5.14487 10.1921 5.3528L10.1448 5.40712L5.65677 9.90745C5.45009 10.1149 5.45009 10.4514 5.65677 10.6588C5.84623 10.849 6.14359 10.8649 6.35118 10.7062L6.40543 10.6586L11.2688 5.78148C11.8886 5.15924 11.8886 4.15038 11.2688 3.52813C10.6759 2.93294 9.73072 2.90707 9.10722 3.4505L9.02426 3.52813L4.16598 8.4055C3.13305 9.4425 3.13305 11.1238 4.16598 12.1608C5.1656 13.1643 6.76627 13.1967 7.80466 12.2579L7.90658 12.1608L12.7649 7.28343C12.9713 7.07617 13.306 7.07617 13.5125 7.28343C13.7017 7.47342 13.7175 7.77162 13.5598 7.97964L13.5125 8.03399L8.65421 12.9114C7.20837 14.3629 4.8642 14.3629 3.41836 12.9114C2.0096 11.4971 1.97348 9.22655 3.31 7.76835L3.41836 7.65494L8.27664 2.77758Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirAttachment);
export default __webpack_public_path__ + "static/media/mir_attachment.00ad3a6f6ee66c5e579fd1712b6b514e.svg";
export { ForwardRef as ReactComponent };